import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {ApiService} from '../../services/api.service';
import {SessionService} from '../../services/session.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  language = '';
  username = '';
  toggleNav: boolean;
    constructor(private authService: AuthenticationService,
                private sessionService: SessionService,
                private translate: TranslateService,
                private router: Router,
                private apiService: ApiService) {
    this.language = translate.currentLang;
  }

  ngOnInit() {
    const username = localStorage.getItem('username');
    this.username = username;
    this.toggleNav = true;
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  canUserSignDoc() {
    return this.authService.isAccountant();
  }

  changeLanguage(lang: string) {
    if (lang === 'en') {
      this.translate.use('en');
      localStorage.setItem('lang', 'en');
      this.sniff('CHANGE_LANG', 'en');
    } else if (lang === 'th') {
      this.translate.use('th');
      localStorage.setItem('lang', 'th');
      this.sniff('CHANGE_LANG', 'th');
    }
  }

  isAdmin() {
    return this.authService.isAdmin();
  }

  isClientAdmin() {
    return this.authService.isClientAdmin();
  }

  isUIH() {
    return this.authService.isUIH();
  }

  isAccountant() {
    return this.authService.isAccountant();
  }

  isAccountantAdmin() {
    return this.authService.isAccountantAdmin();
  }

  isIT() {
    return this.authService.isIT();
  }

  getUsername() {
      return localStorage.getItem('username');
  }

  getRole() {
      return localStorage.getItem('group');
  }

  logout() {
      this.apiService.logout().subscribe(() => {
        this.router.navigate(['/login']);
        this.sessionService.stop();
      });
      this.sniff('LOGOUT', this.username);
  }

  get requireToChangePassword(): boolean {
      return localStorage.getItem('require_to_change_password') === 'true';
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'HOME',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/core/navbar/navbar.component.ts